import config from '../config'

export default [
  'staging',
  'demo',
  'production',
].includes(config.appEnv || '')
